import React, { useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import { updateSundryItem } from '../../../store/actions/sundriesActions'
import { useDispatch, useSelector } from 'react-redux'
import { ERROR } from '../../../store/types'
import TextField from '../../elements/form/TextField'
import RadioGroup from '../../elements/form/RadioGroup'
import NumberField from '../../elements/form/NumberField'

const EditSundryItem = ({closeFunction, item}) => {
  const dispatch = useDispatch()
  const sundriesSelector = useSelector(state => state.sundries)
  const [itemPayload, setItemPayload] = useState(item || {});
  const [validationErrors, setValidationErrors] = useState({});

  const validateForm = () => {
    let errors = {}
    if(!itemPayload.itemName || itemPayload.itemName === '') {
        errors.name = true
    }
    if(!itemPayload.amountType || itemPayload.amountType === '') {
        errors.amountType = true
    }
    if(itemPayload.amountType === 'fixed' && (!itemPayload.amount || itemPayload.amount < 1)) {
        errors.amount = true
    }

    setValidationErrors(errors)

    return errors
  }

  const pushSundryItem = () => {
    if (Object.values(validateForm()).includes(true)) {
      dispatch({
        type: ERROR,
        error: {response: {data: {
            message: 'Please check the highlighted fields'
        }}}
      })
      return
    }
    dispatch(updateSundryItem(item._id, itemPayload))
  }

  const amountTypes = [
    {
      label: 'Fixed',
      description: 'Item has a fixed amount that can only be changed when item is edited',
      value: 'fixed'
    },
    {
      label: 'Variable',
      description: 'Item amount is not fixed or known, an amount will be recorded when a transaction is being recorded',
      value: 'variable'
    }
  ]

  return (
    <div className='w-full'>

      <div className='mt-2'>
        <TextField
          inputLabel="Item name" 
          fieldId="invoice-name" 
          inputType="text" 
          requiredField={true}
          preloadValue={itemPayload.itemName || ''}
          hasError={validationErrors && validationErrors.name} 
          returnFieldValue={(value)=>{setItemPayload({...itemPayload, ...{itemName: value}})}}
        />
      </div>

      <div className='mt-1'>
        <TextField
            inputLabel="Item Description" 
            fieldId="invoice-description" 
            inputType="text" 
            requiredField={false}
            preloadValue={itemPayload.description || ''}
            hasError={validationErrors && validationErrors.description} 
            returnFieldValue={(value)=>{setItemPayload({...itemPayload, ...{description: value}})}}
        />
        {itemPayload?.description?.length > 120 && <p className='text-xs text-red-600 mt-[7px]'>Description is too long, please keep description less than 120 characters</p>}
      </div>

      <div className='mt-1'>
        <RadioGroup 
          items={amountTypes} 
          inline={false}
          preSelectedIndex={amountTypes.findIndex(type => type.value === itemPayload.amountType)}
          inputLabel={'Item Price type'}
          requiredField={true}
          returnSelected={(value) => {setItemPayload({...itemPayload, ...{amountType: value.value}})}} 
          hasError={validationErrors && validationErrors.amountType}  
          titleField='label'
        />
      </div>

      {itemPayload.amountType === 'fixed' && <div className='w-full mt-1'>
        <NumberField
          inputType="number" 
          fieldId={`item-price`}
          inputLabel="Item Price" 
          requiredField={true}
          preloadValue={itemPayload.amount || ''}
          inputPlaceholder='Provide the item price'
          hasError={validationErrors.amount} 
          returnFieldValue={(value)=>{setItemPayload({...itemPayload, ...{amount: value}})}}
        />
      </div>}

      <div className="mt-8 flex flex-row-reverse gap-x-4">
        <ModalActionButton
          buttonLabel={`Update Sundry Item`}
          buttonAction={()=>{pushSundryItem()}}
          processing={sundriesSelector.updating}
        />

        <button
            type="button"
            className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
            onClick={closeFunction}
        >
          Cancel
        </button>
      </div>
    </div>
  )
}

export default EditSundryItem